import * as RxFactory from './api/rx-factory'
import * as Enpoints from './api/endpoints'
export function _executeApi(apiLink, credentials, getToken, commit, callback) {
    try {
        let response_array = []
        if (credentials.localParams.type == 'form') { credentials.globalParams = credentials.globalParams.form }
        if (getToken == '') {
            return
            getToken = ''
        }else if(getToken.Authorization && getToken.Authorization.includes('undefined')){
            return
        }
        credentials.localParams.parameter.pageLoader = true
        let link = (credentials.localParams.link)?apiLink:Enpoints.BASE_URL + apiLink
        if(credentials.localParams.link){
            RxFactory.get(link, credentials.globalParams, getToken)
                .map(response => response.data)
                .subscribe(data => {
                        // console.log('api-data',data,'url',apiLink)
                        // if(Object.keys(data).length == 0){
                        //     callback(false, {"info":"NOK","msg":{"code":"TECH_ERROR","msg":"Some Technical issue"},"data":{},"errors":error})
                        // }
                        // console.log(link, "data should be here", data)
                        credentials.localParams.parameter.pageLoader = false
                        if ('info' in data) {
                            if (data.info === 'OK') {
                                response_array.res_data = data.data
                                callback(false, response_array)
                            } else {
                                if (typeof data.msg == 'object') {
                                    response_array.res_data = data.msg.msg
                                } else {
                                    response_array.res_data = data.msg
                                }
                                callback(true, response_array)
                            }
                        }
                    },
                    e => { _handleErrorResponse(e, commit) })
        }else{
            RxFactory.post(link, credentials.globalParams, getToken)
                .map(response => response.data)
                .subscribe(data => {
                        // console.log('api-data',data,'url',apiLink)
                        // if(Object.keys(data).length == 0){
                        //     callback(false, {"info":"NOK","msg":{"code":"TECH_ERROR","msg":"Some Technical issue"},"data":{},"errors":error})
                        // }
                        credentials.localParams.parameter.pageLoader = false
                        if ('info' in data) {
                            if (data.info === 'OK') {
                                response_array.res_data = data.data
                                callback(false, response_array)
                            } else {
                                if (typeof data.msg == 'object') {
                                    response_array.res_data = data.msg.msg
                                } else {
                                    response_array.res_data = data.msg
                                }
                                callback(true, response_array)
                            }
                        }
                    },
                    e => { _handleErrorResponse(e, commit) })
        }
    } catch (ex) { _handleErrorResponse(ex, commit) }
}
export function _executePostApi(apiLink, credentials, getToken, commit, type = 'Post', callback ) {
    try {
        let response_array = []
        if (getToken == '') {
            return
            getToken = '' 
        }else if(getToken.Authorization && getToken.Authorization.includes('undefined')){
            return
        }
        credentials.localParams.parameter.pageLoader = true;
        RxFactory[type](apiLink, credentials.globalParams, getToken)
            .map(response => response.data)
            .subscribe(data => {
                credentials.localParams.parameter.pageLoader = false
                if ('info' in data) {
                    if (data.info === 'OK') {
                        response_array.res_data = data.data
                        callback(false, response_array)
                    } else {
                        if (typeof data.msg == 'object') {
                            response_array.res_data = data.msg.msg
                        } else {
                            response_array.res_data = data.msg
                        }
                        callback(true, response_array)
                    }
                }
            },
            e => { _handleErrorResponse(e, commit) })
    } catch (ex) { _handleErrorResponse(ex, commit) }
}
export function _executeGetApi(apiLink, credentials, getToken, commit, callback) {
    try {
        let response_array = [];
        credentials.localParams.parameter.pageLoader = true
        RxFactory.get(apiLink, credentials.globalParams, getToken)
            .map(response => response.data)
            .subscribe(data => {
                credentials.localParams.parameter.pageLoader = false
                if ('info' in data) {
                    if (data.info === 'OK') {
                        response_array.res_data = data.data
                        callback(false, response_array)
                    } else {
                        if (typeof data.msg == 'object') {
                            response_array.res_data = data.msg.msg
                        } else {
                            response_array.res_data = data.msg
                        }
                        callback(true, response_array)
                    }
                }
            },e => { _handleErrorResponse(e, commit) })
    } catch (ex) { _handleErrorResponse(ex, commit) }
}

export function _messageDisplayFunction(getParameter, getMessage, msgType) {
    //getParameter.response_msg = getMessage
    //getParameter.msg_type = msgType
    getParameter.$notify({
        group: 'foo',
        type: msgType,
        text: getMessage,
        duration: 10000,
        closeOnClick: true
    });
}

export function _cleanUp(commit, msg, status, loaderId) {
    let loaderArr = (typeof loaderId !== 'undefined') ? [loaderId] : []
    commit("SET_INFO", msg)
}

export function _handleErrorResponse(e, commit) {
    let response = { info: 'NOK', msg: 'Service not available' }
    if (typeof e.response === 'undefined') {
        try {
            const statusCheck = e.toString().toLowerCase()
            if (statusCheck.indexOf('network') > -1) {
                response = { info: 'NOK', msg: 'Network Error' }
            }
        } catch (e) {}
    } else {
        response = e.response.data
    }
    _cleanUp(commit, response, response.status)
    if (typeof e.response !== 'undefined') {
        if (e.response.status == 401) {
            let data = {}
            let options = {}
            options.forward = true
            _handleLogout(data, commit, options)
        }
    }
}

export function _handleLogout(data, commit, options) {
    const router = options.router
    let user = {}
    localStorage.clear();
    if ('msg' in data && 'info' in data) {
        _cleanUp(commit, data.msg, data.info)
    }
    if (options.forward === true) {
        window.location.replace("/")
    }
}

export function flattenJSONStrings(obj) {
    const result = Object.assign({}, obj || {});
    for (const key in result) {
        if (typeof result[key] === 'string') {
            try {
                const parsed = JSON.parse(result[key]);
                // If parsed is an object, flatten it recursively
                if (typeof parsed === 'object' && parsed !== null) {
                    delete result[key];
                    const flattened = flattenJSONStrings(parsed);
                    Object.assign(result, flattened);
                }
            } catch (e) { }
        }
    }
    return result;
}

export function _setDrawingToolLocalStorage(drawingsData){
    if(drawingsData.theme && Object.keys(drawingsData.theme).length){
        localStorage.setItem('CIQ.Themes.prototype.custom', JSON.stringify(drawingsData.theme))
    }
    if(!!drawingsData && drawingsData.drawingIsins && drawingsData.drawingIsins.length > 0){
    let drawingIsins = drawingsData.drawingIsins || []
    let _drawings = drawingsData._drawings || {}
    _drawings = normalizeKeys(_drawings, "#", ".")
    if(typeof _drawings === 'object' && Object.keys(_drawings).length > 0){
        localStorage.setItem('_drawings', JSON.stringify(_drawings))
    }
    if(Array.isArray(drawingIsins) && drawingIsins.length > 0){
       drawingIsins = normalizeKeys(drawingIsins, "#", ".")
        localStorage.setItem('previousDrawings',JSON.stringify([...drawingIsins]))
        drawingIsins.forEach((isin)=>{
            let currentIsinKey = Object.keys(isin)
            currentIsinKey = currentIsinKey.length > 0 ? currentIsinKey[0] : null
            const currentIsinValue = !currentIsinKey ? [] : isin[currentIsinKey]
            if(Array.isArray(currentIsinValue) && currentIsinValue.length > 0 && !!currentIsinKey){
                localStorage.setItem(currentIsinKey, JSON.stringify(currentIsinValue))
            }
        })}
    }
}

/**
 * Normalizes object/array keys by replacing a given symbol with another symbol.
 *
 * @param {Object|Array} input - The object or array to process
 * @param {string} fromSymbol - Symbol to replace (e.g. "#" or "-")
 * @param {string} toSymbol - Symbol to replace with (e.g. "-" or "#")
 * @returns {Object|Array} - A new object/array with keys normalized
 */


export function normalizeKeys(input, fromSymbol, toSymbol) {

    // Skip non-objects (numbers, strings, null, undefined, etc.)
    if (!input || typeof input !== "object") {
        return input;
    }

    // Handle empty array
    if (Array.isArray(input) && input.length === 0) {
        return [];
    }

    // Handle empty object
    if (!Array.isArray(input) && Object.keys(input).length === 0) {
        return {};
    }

    let normalized = Array.isArray(input)
        ? input.slice()
        : Object.assign({}, input);

    if (Array.isArray(normalized)) {
        normalized = normalized.map((item) => {
            if (typeof item !== "object" || item === null) return item;

            const newItem = Object.assign({}, item);
            for (const key in newItem) {
                if (Object.hasOwn(newItem, key) && key.includes(fromSymbol)) {
                    const newKey = key.replace(
                        new RegExp(escapeRegExp(fromSymbol), "g"),
                        toSymbol
                    );
                    newItem[newKey] = newItem[key];
                    delete newItem[key];
                }
            }
            return newItem;
        });
    } else {
        for (const key in normalized) {
            if (Object.hasOwn(normalized, key) && key.includes(fromSymbol)) {
                const newKey = key.replace(
                    new RegExp(escapeRegExp(fromSymbol), "g"),
                    toSymbol
                );
                normalized[newKey] = normalized[key];
                delete normalized[key];
            }
        }
    }

    return normalized;
}

function escapeRegExp(str) {
    if (typeof str !== "string") {
        throw new TypeError(`escapeRegExp expected a string, got ${typeof str}`);
    }

    if (str.length === 0) {
        // Nothing to escape, return empty string
        return "";
    }

    return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}




// WEBPACK FOOTER //
// ./src/store/commomFunction.js